export default __webpack_public_path__ + "img/165449f70d9491efeb27cfa09db803bb.svg";